<template>
    <div class="book-item" @click="goDetail" :title="item.bookName">
      <div class="item-pic">
        <span class="recomand-label" v-if="item.recommend>0">荐</span>
        <img class="image" :src="item.cover_img" @error="imgError(item)" />
      </div>
      <div class="item-txt">
        <h3 class="item-title" :title="item.title">{{ item.title }}</h3>
        <div class="item-sub ellipsis" :title="item.author" v-if="item.author">责任者/责任方式：{{ item.author }}</div>
        <p  class="item-btn" @click="goDetail">立即阅读</p>
      </div>
    </div>
</template>

<script>

export default {
  name: 'BookItem',
  props: {item:Object},
  data(){
    return{
       
    }
  },
methods:{
  goDetail(){
    this.$router.push({
      path:'/book/'+this.item.id,
    })
  }
},
}
</script>
<style scoped lang="scss">
@import "@/assets/sass/_config";
.book-item {
  transition: all 0.3s;
  &:hover {
    .item-title {
      color: $main-color;
    }
  }
  .item-txt {
    .item-sub {
      width: 100%;
      text-align: center;
    }
  }
}
</style>